(function () {
  'use strict';
  if (window.__isdCartFixV4) return;
  window.__isdCartFixV4 = true;
  var offerRE = /^Add\s+(\d+)\s+more\s+to\s+get\s+(\d+(?:[.,]\d+)?)\s*%\s*off!?$/i;
  var busy = false;
  function translateNode(node) {
    if (!node) return;
    if (node.nodeType === 3) {
      var raw = node.nodeValue || '', val = raw.trim(), match = val.match(offerRE);
      if (match) node.nodeValue = raw.replace(val, 'Pridėkite dar ' + match[1] + ' vnt. ir sutaupykite ' + match[2] + ' %');
      return;
    }
    if (node.nodeType !== 1 || node.matches('script,style,textarea,noscript')) return;
    var text = node.textContent || '';
    if (!/Add\s+\d+\s+more\s+to\s+get\s+\d/i.test(text)) return;
    var walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT), child;
    while ((child = walker.nextNode())) translateNode(child);
  }
  function fixModalScrolling() {
    var dialogs = document.querySelectorAll('[role="dialog"],[aria-modal="true"]');
    dialogs.forEach(function (dialog) {
      if (dialog.closest('[data-sk-drawer]') || dialog.hasAttribute('data-sk-drawer')) return;
      var rect = dialog.getBoundingClientRect();
      if (rect.width < 280 || rect.height < 280 || rect.bottom < 0) return;
      dialog.setAttribute('data-lenis-prevent', '');
      dialog.style.setProperty('touch-action', 'pan-y');
      var nodes = [dialog].concat(Array.prototype.slice.call(dialog.querySelectorAll('main,aside,section,div')));
      nodes.forEach(function (el) {
        if (el.clientHeight < 140 || el.scrollHeight < el.clientHeight + 24) return;
        var overflow = getComputedStyle(el).overflowY;
        if (overflow === 'hidden' || overflow === 'clip') {
          el.style.setProperty('overflow-y', 'auto', 'important');
          el.style.setProperty('min-height', '0');
          el.style.setProperty('overscroll-behavior-y', 'contain');
        }
      });
    });
  }
  function scan() {
    if (busy) return;
    busy = true;
    requestAnimationFrame(function () {
      busy = false;
      translateNode(document.body);
      fixModalScrolling();
    });
  }
  function init() {
    scan();
    new MutationObserver(function (mutations) {
      var should = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'characterData') {
          translateNode(m.target);
        } else {
          for (var j = 0; j < m.addedNodes.length; j++) {
            translateNode(m.addedNodes[j]);
            should = true;
          }
        }
      }
      if (should) scan();
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
    document.addEventListener('click', function () { window.setTimeout(scan, 120); }, true);
    window.addEventListener('resize', scan, { passive: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();